import React, { useState, useEffect } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import { useTranslate } from "../../hooks/LanguageProvider";
import moment from "moment";

interface ModalShowSiteProps {
  show: boolean;
  onHide: () => void;
  id_site: number | null;
}

const backendUrl = process.env.REACT_APP_BACKEND_URL;

const ModalShowSite: React.FC<ModalShowSiteProps> = ({
  show,
  onHide,
  id_site,
}) => {
  const [siteData, setSiteData] = useState({
    id_site: "",
    name: "",
    location: "",
    created_at: "",
    //updated_at: "",
  });

  const { translate } = useTranslate();

  const getSiteById = async (id_site: number) => {
    try {
      const response = await fetch(
        `${backendUrl}/api/site/details/${id_site}`,
        {
          method: "GET",
          credentials: "include",
          headers: { "Content-Type": "application/json" },
        }
      );

      if (!response.ok) {
        throw new Error("Error retrieving site");
      }

      const site = await response.json();
      return site || null;
    } catch (error) {
      console.error("Error retrieving site:", error);
      return null;
    }
  };

  useEffect(() => {
    if (show && id_site) {
      getSiteById(id_site).then((site) => {
        const s = Array.isArray(site) ? site[0] : site;
        if (s) {
          setSiteData({
            id_site: s.id_site || "",
            name: s.name || s.site || "", // Use whatever field contains the name
            location: s.location || "",
            created_at: s.created_at 
              ? moment(s.created_at).format("YYYY-MM-DD") : "",
            //updated_at: s.updated_at 
            //  ? moment(s.updated_at).format("YYYY-MM-DD") : ""
          });
        }
      });
    }
  }, [show, id_site]);

  return (
    <Modal show={show} onHide={onHide} responsive>
      <Modal.Header closeButton>
        <Modal.Title>{translate("Site Details")}</Modal.Title>
      </Modal.Header>

      <Modal.Body style={{ maxHeight: "calc(80vh - 200px)", overflowY: "auto" }}>
        <Form style={{ color: "#000", fontSize: "18px" }}>
          <Form.Group>
            <Form.Label>{translate("Site Name")}:</Form.Label>
            <p className="form-text">{siteData.name}</p>
          </Form.Group>

          <Form.Group>
            <Form.Label>{translate("location")}:</Form.Label>
            <p className="form-text">{siteData.location}</p>
          </Form.Group>

          <Form.Group>
            <Form.Label>{translate("Created At")}:</Form.Label>
            <p className="form-text">{siteData.created_at}</p>
          </Form.Group>

          {/*<Form.Group>
            <Form.Label>{translate("Last Updated")}:</Form.Label>
            <p className="form-text">{siteData.updated_at}</p>
          </Form.Group>*/}
        </Form>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          {translate("Close")}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalShowSite;